import type {
  Options,
  QueryKey,
  SearchItemsData
} from '@metto/http-clients/api';
import {
  createBookmarkByUrlMutation,
  queryClient
} from '@metto/http-clients/api';
import { useMutation } from '@metto/http-clients/react-query';

export const useCreateBookmarkByUrlMutation = () => {
  return useMutation({
    ...createBookmarkByUrlMutation(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        predicate: ({ queryKey }) => {
          const keyArray = queryKey as QueryKey<Options<SearchItemsData>>;

          return keyArray.some(key => key._id === 'getItems');
        }
      });
    }
  });
};
